








































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { percentFromTotal } from "../../../utils";
import {
  ConcisenessRepetition,
  SentenceLengthDistribution
} from "../../../types/NewResults";

// import AssetsMixin from "@/AssetsMixin";
// import Card from "../Card.vue";

@Component({
  components: {}
})
export default class SentenceLength extends Vue {
  
  @Prop() private slength!: SentenceLengthDistribution;
  @Prop() private totalSentences!: number;

  private percentFromTotal = percentFromTotal;
  private colors: string[] = ["#38D17A", "#FFCC00", "#F74657"];
  private scalePercentage: number[] = [];
  private labels: string[] = [];
  private averageSentenceDescription: string = ""
  private averageSentenceColor: string = this.colors[0]
  private averageWordPercentage = 0;

  private created() {
    this.displayData()
  }

  @Watch("slength")
  private displayData() {

    if(this.slength && this.slength.scale.length>=2) {

      let firstScale = this.slength.scale[0]
      let lastScale = this.slength.scale[this.slength.scale.length-1]
      let bufferedProgress = lastScale - firstScale

      if(this.slength.averageLength < firstScale) {
        this.averageSentenceColor = this.colors[0]
      } else if(this.slength.averageLength <= lastScale) {
        this.averageSentenceColor = this.colors[1]
      } else {
        this.averageSentenceColor = this.colors[2]
      }

      const fpr = percentFromTotal(firstScale-1, lastScale)
      const bpr = percentFromTotal(bufferedProgress*2, lastScale)
      const lpr = (fpr+bpr)*0.7

      this.scalePercentage.push(fpr)
      this.labels.push("<"+firstScale)
      this.scalePercentage.push(bpr)
      this.labels.push(firstScale+"-"+lastScale)
      this.scalePercentage.push(lpr)
      this.labels.push(">"+lastScale)
       
      const firstPart = percentFromTotal(fpr, fpr+bpr+lpr)
      const secondPart = percentFromTotal(bpr, fpr+bpr+lpr)
      const lastPart = percentFromTotal(lpr, fpr+bpr+lpr)

      const minLimit = -9.5
      const maxLimit = 90.5

      if(this.slength.averageLength<firstScale) {
        const scale = firstScale-1
        const multi = firstPart/scale
        this.averageWordPercentage = (this.slength.averageLength*multi)+minLimit
        if(this.averageWordPercentage < minLimit){
          this.averageWordPercentage = minLimit
        }
      } else if(this.slength.averageLength<=lastScale) {
        const scale = bufferedProgress
        const multi = (secondPart/scale)
        this.averageWordPercentage = (this.slength.averageLength*multi) - firstPart - 11.5
      } else {
        const scale = firstScale
        const multi = lastPart/scale
        this.averageWordPercentage = (this.slength.averageLength*multi)+minLimit
        if(this.averageWordPercentage>maxLimit){
          this.averageWordPercentage = maxLimit
        } 
      }

      const valuesInLimit = this.slength.values[0]
      if(this.totalSentences===1) {
        const valuesInMaxLimit = this.slength.values[this.slength.values.length-1]
        if(valuesInLimit > 0) {
          this.averageSentenceDescription = "You only spoke 1 sentence and it was a good length (< "+firstScale+" words)."
        } else if(valuesInMaxLimit > 0) {
          this.averageSentenceDescription = "You only spoke 1 sentence and it was way too long ("+lastScale+"+ words)."
        } else {
          this.averageSentenceDescription = "You only spoke 1 sentence and it was a bit long ("+firstScale+"+ words)."
        }
      } else if(valuesInLimit === this.totalSentences) {
          this.averageSentenceDescription = "Great job! <b>None of your "+valuesInLimit+"</b> sentences were too long ("+firstScale+"+ words)."
      } else {
          const valuesNotInLimit = this.totalSentences - valuesInLimit
          this.averageSentenceDescription = "Overall, <b>"+valuesNotInLimit+" out of "+this.totalSentences+"</b> of your sentences were too long ("+firstScale+"+ words)."
      }
    }
  }
}
